/**
 * Local Delivery - Postal validation (SG 6-digit, sector 01-82)
 */
(function () {
  'use strict';

  var HOSPITAL_POSTAL_CODES = [
    '169608','119074','308433','529889',
    '768828','159964','228510','258500',
    '574623','188770','229899','307506',
    '329563','238859','258499','248649',
    '308443','119082','168582','168753',
    '168938','169609','169856','329562',
    '427990','529895','544835','544886',
    '569766','609606','768024',
  ];

  function isHospitalPostal(code) {
    var p = String(code || '').trim();
    return HOSPITAL_POSTAL_CODES.indexOf(p) >= 0;
  }

  function exceptionApplies(exception, referenceDate) {
    if (!exception) return false;
    var from = String(exception.valid_from || '').trim();
    var to = String(exception.valid_to || '').trim();
    if (!from && !to) return true;
    if (!from || !to) return false;
    if (!referenceDate) return true;
    return referenceDate >= from && referenceDate <= to;
  }

  function validatePostalClient(code, excludedAreas, excludedPrefixes, allowedExceptions, referenceDate, scheduledExclusions) {
    var p = String(code || '').trim();
    if (!/^\d{6}$/.test(p)) return { valid: false, excluded: false, hospital: false };
    var sector = parseInt(p.slice(0, 2), 10);
    if (sector < 1 || sector > 82) return { valid: false, excluded: false, hospital: false };
    var hospital = isHospitalPostal(p);
    if (hospital) return { valid: true, excluded: false, hospital: true };
    if (allowedExceptions && allowedExceptions.length) {
      var allowed = allowedExceptions.some(function (exception) {
        return exception && String(exception.postal_code || '').trim() === p &&
          exceptionApplies(exception, referenceDate);
      });
      if (allowed) return { valid: true, excluded: false, hospital: false, allowedException: true };
    }
    if (excludedAreas && excludedAreas.length) {
      var areaMatch = excludedAreas.some(function (rawArea) {
        var area = String(rawArea || '').trim();
        if (!area) return false;
        if (/^\d+$/.test(area)) return area.length === 6 ? p === area : p.indexOf(area) === 0;
        return p.toLowerCase().indexOf(area.toLowerCase()) >= 0 || area.toLowerCase().indexOf(p.toLowerCase()) >= 0;
      });
      if (areaMatch) return { valid: true, excluded: true, hospital: false };
    }
    if (excludedPrefixes && excludedPrefixes.length) {
      var match = excludedPrefixes.some(function (pre) {
        return pre && p.indexOf(pre) === 0;
      });
      if (match) return { valid: true, excluded: true, hospital: false };
    }
    // Before a date is chosen, keep the calendar reachable for advance bookings.
    var today = new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString().slice(0, 10);
    var scheduled = scheduledExclusions && scheduledExclusions.find(function (entry) {
      return entry && (referenceDate ? referenceDate >= entry.valid_from && referenceDate <= entry.valid_to : entry.valid_to >= today) &&
        Array.isArray(entry.prefixes) && entry.prefixes.some(function (prefix) {
          return /^\d{1,6}$/.test(prefix) && p.indexOf(prefix) === 0;
        });
    });
    if (scheduled) return { valid: true, excluded: !!referenceDate, hospital: false, scheduledExclusion: !!referenceDate, scheduledNotice: !referenceDate,
      message: String(scheduled.message || '').trim() || (referenceDate
        ? 'Delivery is not available to this area on ' + referenceDate + '. Please choose another delivery date or self-collection.'
        : 'Delivery is not available to this area from ' + scheduled.valid_from + ' to ' + scheduled.valid_to + '. Please choose another delivery date or self-collection.') };
    return { valid: true, excluded: false, hospital: false };
  }

  function checkCheckoutPostal(fetchPostal, config, code, deliveryDate) {
    if (isHospitalPostal(code)) return Promise.resolve('');
    config = config || {};
    var rules = config.scheduled_postal_exclusions || [];
    var needsConfirmation = rules.some(function (entry) {
      return entry && Array.isArray(entry.prefixes) && entry.prefixes.some(function (prefix) {
        return /^\d{1,6}$/.test(prefix) && code.indexOf(prefix) === 0;
      });
    });
    var local = validatePostalClient(code, config.excluded_areas, config.excluded_postal_prefixes,
      config.allowed_postal_exceptions, deliveryDate, rules);
    if (!local.valid || local.excluded) return Promise.resolve(local.message || 'Delivery is not available to this area on that date. Please choose another delivery date or self-collection.');
    return fetchPostal(code, deliveryDate).then(function (result) {
      if (result && (!result.valid || result.excluded)) {
        return result.message || 'Delivery is not available to this area on that date. Please choose another delivery date or self-collection.';
      }
      if (!result && needsConfirmation) return 'We could not confirm delivery availability for this area. Please try again.';
      return '';
    });
  }

  window.WF_LD_POSTAL_UTILS = {
    validatePostalClient: validatePostalClient,
    checkCheckoutPostal: checkCheckoutPostal,
    isHospitalPostal: isHospitalPostal,
  };
})();
